@if (hasRating) {
    @for (i of starArray; track $index) {
        <vn-icon class="star-rating-full" name="theme-favorite-star-multicolor" size="11"></vn-icon>
    }
    @for (i of emptyStarArray; track $index) {
        <vn-icon class="star-rating-empty" name="theme-favorite-star-multicolor" size="11"></vn-icon>
    }
}
